@if (visible() && note(); as n) {
  <div
    class="viewer-backdrop"
    (click)="onBackdrop($event)"
    (keydown)="onKey($event)"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="'notes.viewer.aria' | t"
  >
    <div class="viewer-card">
      <header class="viewer-header">
        <span class="viewer-cell">{{ cellLabel() }}</span>
        <button class="viewer-close" type="button" (click)="close()" [attr.aria-label]="'notes.close' | t">×</button>
      </header>

      <article class="viewer-body">
        <p class="viewer-text">{{ n.text }}</p>
      </article>

      <footer class="viewer-footer">
        <div class="viewer-actions">
          <button class="action edit" type="button" (click)="edit()">{{ 'notes.edit' | t }}</button>
          <button class="action add" type="button" (click)="addAnother()">{{ 'notes.add.another' | t }}</button>
        </div>
      </footer>
    </div>
  </div>
}
